import { render, staticRenderFns } from "./MarketSelector.vue?vue&type=template&id=36daa11a&scoped=true&"
import script from "./MarketSelector.vue?vue&type=script&lang=js&"
export * from "./MarketSelector.vue?vue&type=script&lang=js&"
import style0 from "./MarketSelector.vue?vue&type=style&index=0&id=36daa11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36daa11a",
  null
  
)

export default component.exports